import React from 'react';

import { ListItemIcon } from '@mui/material';

import type { DeclarativeMenuItemProps } from './DeclarativeMenuItem';

export function DeclarativeMenuItemIcon(props: Pick<DeclarativeMenuItemProps, 'icon'>) {
  const { icon } = props;
  if (icon === 'none') return null;
  return (
    <ListItemIcon
      sx={{
        '& .MuiSvgIcon-root': { height: 22, width: 22 },
        '& svg.lucide': { height: 20, strokeWidth: 1.75, width: 20 },
        color: 'inherit',
        minWidth: 24,
        position: 'relative',
      }}
    >
      {icon === 'gap' ? null : icon}
    </ListItemIcon>
  );
}
